"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// 下拉選單用
exports.localeOptions = [
    { language: 'zh-tw', label: '繁體中文' },
    { language: 'en-us', label: 'English' },
];
exports.LocaleContext = react_1.createContext([null, null]);
function useNavigatorLanguage() {
    var _a = react_1.useState(navigator.language.toLocaleLowerCase()), locale = _a[0], setLocale = _a[1];
    return [locale, setLocale];
}
exports.default = useNavigatorLanguage;
